import styled from 'styled-components';
import { CalendarIcon } from '../Icons';

export const Container = styled.div`
  position: relative;
  input{
    height: 100%;
    width: 100%;
    color: ${(props) => props.theme.colors.text.default};
    font-size: 12px;
    background-color: ${(props) => props.theme.colors.editSurveyBackgroundColor};
    padding: 10px 35px 10px 16px;
    border-radius: 10px;
    border: 0;

    &::placeholder {
      color: ${(props) => props.theme.colors.text.placeholder};
      font-weight: 300;
    }
  }
  .react-datepicker__triangle::before{
    border-bottom-color:${(props) => props.theme.colors.calendarHeaderBackgroundColor} !important;
  }
  .react-datepicker__triangle{
    border-top: ${(props) => props.theme.colors.calendarHeaderBackgroundColor} !important;
    border-bottom-color:${(props) => props.theme.colors.calendarHeaderBackgroundColor} !important;
    left:80px !important;
  }
  .react-datepicker{
    border:0px;
  }
  .react-datepicker-wrapper{
    font-family: "Roboto", "Helvetica neue", "Lato", sans-serif;
    width:100%;
  }
  .react-datepicker__current-month{
    font-size: 13px;
    color: ${(props) => props.theme.colors.calendarMonthFontColor};
  }
  .react-datepicker__day-name{
    margin:5px;
    color: ${(props) => props.theme.colors.calendarMonthFontColor};
  }
  .react-datepicker__day {
    &:hover {
      background-color: ${(props) => props.theme.colors.calendarSelectedDay};
    }
    margin:5px;
    color: ${(props) => props.theme.colors.calendarDaysMonthFontColor};
  }
  .react-datepicker__day-names{
    margin-right:5px;
    color: ${(props) => props.theme.colors.calendarMonthFontColor};
  }
  .react-datepicker__header {
    background-color: ${(props) => props.theme.colors.calendarHeaderBackgroundColor};
    border: 0px;
  }
  .react-datepicker__month-container{
    width: 215px;
    height: 224px;
    font-size: 13px;
    background-color:${(props) => props.theme.colors.calendarBodyBackgroundColor};
  }
  .react-datepicker__navigation{
    color: ${(props) => props.theme.colors.calendarDaysMonthFontColor};
  }
  .react-datepicker__day--outside-month{
    opacity: 0.4;
  }
  .react-datepicker__day--selected{
    background-color: ${(props) => props.theme.colors.calendarSelectedDay};
    color: ${(props) => props.theme.colors.calendarMonthFontColor};
  }
`;
export const Calendar = styled(CalendarIcon)`
  fill: ${(props) => props.theme.colors.calendarMonthFontColor}; 
  position: absolute;
  top: 9px;
  right: 10px;
`;
